<template>
  <section class="reply-refer-form">
    <el-form
      ref="form"
      :model="item"
      :rules="formRules">
      <div v-show="item.quote_status == 0 && editType == 3">
        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Insurer Quote Status</span>
            <el-form-item
              ref="quote_status"
              prop="quote_status">
              <v-radio-group
                v-model="item.quote_status"
                :border="true"
                :list="quoteStatusOptions" />
            </el-form-item>
          </div>
        </div>
        <div class="box">
          <div class="form-item form-half">
            <span>Insurer</span>
            <el-form-item
              ref="company_id"
              prop="company_id">
              <v-select
                v-model="item.company_id"
                :list="localAllOptions.insurer"
                :disabled="editType == 3 && index == 0"
                @change="()=>(formDataLock+=1)" />
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Class of Insurance</span>
            <el-form-item>
              <v-select
                v-model="item.plan_id"
                :list="currentPlanList"
                :disabled="showBuyable"
                @change="changePlan" />
            </el-form-item>
          </div>
          <div
            v-if="item.quote_status==0"
            class="form-item form-half">
            <span>Reject Renewal Notice</span>
            <el-form-item
              ref="renew_file_path_id"
              prop="renew_file_path_id">
              <v-upload
                card
                widthFull
                :fileData="reject_fileData[index]"
                :otherData="otherData"
                @delete="handleDel"
                @uploadSuccess="handlerUploadSuccess" />
            </el-form-item>
          </div>
        </div>
      </div>
      <div v-show="(item.quote_status != 0 && editType == 3) || editType != 3">
        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Insurer Quote Status</span>
            <el-form-item
              ref="quote_status"
              prop="quote_status">
              <v-radio-group
                v-model="item.quote_status"
                :border="true"
                :disabled="showBuyable || editType == 2"
                :list="quoteStatusOptions" />
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Total Payable</span>
            <span>{{ item.payable }}</span>
          </div>
        </div>
        <div class="box">
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Insurer</span>
              <el-form-item
                ref="company_id"
                prop="company_id">
                <v-select
                  v-model="item.company_id"
                  :list="localAllOptions.insurer"
                  :disabled="showBuyable || (editType == 3 && index == 0)"
                  @change="changeCompany"/>
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Type of Insurance</span>
              <v-select
                v-model="item.class_id"
                :disabled="true"
                :list="classOptions" />
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Class of Insurance</span>
              <el-form-item
                ref="plan_id"
                prop="plan_id">
                <v-select
                  v-model="item.plan_id"
                  :list="currentPlanList"
                  :disabled="showBuyable"
                  @change="changePlan"/>
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Policyholder</span>
              <v-input
                v-model="item.isrd_nm"
                :disabled="true" />
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Quotation Number</span>
              <v-input
                v-model="item.quote_no"
                :disabled="true" />
            </div>
            <div class="form-item form-half">
              <span>Type of quotation</span>
              <v-select
                v-model="item.type"
                :disabled="true"
                :list="globalOptions.quote_type" />
            </div>
          </div>
          <div
            class="flex-sb">
            <div class="form-item form-half">
              <span>Expected Effective Date </span>
              <el-form-item
                ref="pcy_cmnt_dt"
                prop="pcy_cmnt_dt">
                <v-date-picker
                  v-model="item.pcy_cmnt_dt"
                  :disabled="showBuyable || Boolean(item.pcy_cmnt_dt)"/>
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Expected Expiry Date</span>
              <el-form-item
                ref="pcy_expry_dt"
                prop="pcy_expry_dt">
                <v-date-picker
                  v-model="item.pcy_expry_dt"
                  :disabled="showBuyable || item.pcy_expry_dt != ''"/>
              </el-form-item>
            </div>
          </div>
        <!--        <div class="flex-sb">-->
        <!--          <div class="form-item form-half">-->
        <!--            <span>Quote Date</span>-->
        <!--            <v-date-picker-->
        <!--              v-model="item.quote_no"-->
        <!--            />-->
        <!--          </div>-->
        <!--          <div class="form-item form-half">-->
        <!--            <span>Policy Period</span>-->
        <!--            <v-date-picker-->
        <!--              v-model="item.type"-->
        <!--              type="daterange"-->
        <!--            />-->
        <!--          </div>-->
        <!--        </div>-->
        </div>
        <div class="box">
          <h3>Coverage</h3>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Medical Expenses</span>
              <v-input
                v-model="item.medical_expenses"
                :keyFloatNumber="true"
                negativeNumber
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
            <div class="form-item form-half">
              <span>Hospital Cash</span>
              <v-input
                v-model="item.hospital_cash"
                :keyFloatNumber="true"
                negativeNumber
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
          <!--          <div class="form-item form-half">-->
          <!--            <span>Trip Interruption</span>-->
          <!--            <v-input v-model="item.clinical_expenses" />-->
          <!--          </div>-->
          </div>
          <div class="flex-sb">

            <div class="form-item form-half">
              <span>Travel Delay</span>
              <v-input
                v-model="item.travel_delay"
                :keyFloatNumber="true"
                negativeNumber
                maxlength="9"
                :disabled="showBuyable"
              />
            </div>
            <div class="form-item form-half">
              <span>Trip Cancellation</span>
              <v-input
                v-model="item.trip_cancellation"
                :keyFloatNumber="true"
                negativeNumber
                maxlength="9"
                :disabled="showBuyable"/>
            </div>

          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Burns Benefit </span>
              <v-input
                v-model="item.burns_benefit"
                :keyFloatNumber="true"
                negativeNumber
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
            <div class="form-item form-half">
              <span>Baggage Delay</span>
              <v-input
                v-model="item.baggage_delay"
                :keyFloatNumber="true"
                negativeNumber
                maxlength="9"
                :disabled="showBuyable"/>
            </div>

          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Personal Accident</span>
              <v-input
                v-model="item.personal_accident"
                :keyFloatNumber="true"
                negativeNumber
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
            <div class="form-item form-half">
              <span>Rental Vehicle Excess</span>
              <v-input
                v-model="item.rental_vehicle_excess"
                :keyFloatNumber="true"
                negativeNumber
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>24-Hour Worldwide Assistance Services</span>
              <v-input
                v-model="item.worldwide_service"
                :keyFloatNumber="true"
                negativeNumber
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
            <div class="form-item form-half">
              <span>Personal Liability</span>
              <v-input
                v-model="item.personal_liability"
                :keyFloatNumber="true"
                negativeNumber
                :disabled="showBuyable"
                maxlength="9"/>
            </div>

          </div>
          <div class="flex-sb">

            <div class="form-item form-half">
              <span>Home Contents Protection</span>
              <v-input
                v-model="item.home_protection"
                :keyFloatNumber="true"
                maxlength="9"
                negativeNumber
                :disabled="showBuyable"/>
            </div>
            <div class="form-item form-half">
              <span>Personal Property</span>
              <v-input
                v-model="item.personal_property"
                :keyFloatNumber="true"
                maxlength="9"
                negativeNumber
                :disabled="showBuyable"/>
            </div>

          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Loss of Travel Documents</span>
              <v-input
                v-model="item.loss_of_documents"
                :keyFloatNumber="true"
                negativeNumber
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
            <div class="form-item form-half">
              <span>Personal Money</span>
              <v-input
                v-model="item.personal_money"
                :keyFloatNumber="true"
                negativeNumber
                maxlength="9"
                :disabled="showBuyable"/>
            </div>

          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Credit Card Protection</span>
              <v-input
                v-model="item.credit_protection"
                :keyFloatNumber="true"
                negativeNumber
                maxlength="9"
                :disabled="showBuyable"/>
            </div>
          </div>
          <div
            v-if="plan_cvr_remark"
            class="form-item">
            <span>Plan Coverage Remark</span>
            <span>{{plan_cvr_remark}}</span>
          </div>
          <div class="flex-sb">
            <div class="form-half">
              <div class="form-item">
                <span>Coverage Remark</span>
                <v-input
                  v-model="item.cvr_remark"
                  type="textarea"
                  :rows="3"
                />
              </div>
            </div>
          </div>
        <!--        <div class="flex-sb">-->

        <!--          &lt;!&ndash;          <div class="form-item form-half">&ndash;&gt;-->
        <!--          &lt;!&ndash;            <span>Cruise Benefits (Applicable to Cruise Worldwide and Cruise Asia Plans Only)</span>&ndash;&gt;-->
        <!--          &lt;!&ndash;            <v-input v-model="item.personal_effects" />&ndash;&gt;-->
        <!--          &lt;!&ndash;          </div>&ndash;&gt;-->
        <!--        </div>-->
        <!--        <div class="flex-sb">-->

        <!--        </div>-->
        </div>
        <!--      <div class="box">-->
        <!--        <span class="title">More Benefits</span>-->
        <!--        <div class="form-item">-->
        <!--          <v-checkbox-group-->
        <!--            v-model="item.benefits"-->
        <!--            :block="true"-->
        <!--            :disabled="showBuyable"-->
        <!--            :list="localAllOptions.benefits">-->
        <!--            &lt;!&ndash;            <template v-slot:input="input">&ndash;&gt;-->
        <!--            &lt;!&ndash;              <v-input v-model="item.benefit_coverage[input.id]" />&ndash;&gt;-->
        <!--            &lt;!&ndash;            </template>&ndash;&gt;-->
        <!--          </v-checkbox-group>-->
        <!--        </div>-->

        <!--      </div>-->
        <benefit-form
          ref="benefit-form"
          :form="item"
          :disabled="showBuyable"
          :classId="item.class_id"
          :editType="editType"
          :renewOrderId="renewOrderId"
          :formDataLock="excessFormDataLock"
          @getSubmitPremium="getSubmitPremium"
          @getFormData="submitPremium" />
        <!--      <div class="box">-->
        <!--        <h3>Underwriting Question</h3>-->
        <!--        <div class="flex-sb-wrap">-->
        <!--          <div-->
        <!--            v-for="(inItem, inIndex) in item.underwriting"-->
        <!--            :key="inIndex"-->
        <!--            class="form-item form-half">-->
        <!--            <span>{{ inItem.name }}</span>-->
        <!--            <v-radio-group-->
        <!--              v-model="inItem.answer"-->
        <!--              :border="true"-->
        <!--              :list="yesNoOptions" />-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <div class="box">
          <h3>Remarks</h3>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Policy Remark</span>
              <v-input
                v-model="item.cs_manual_remark"
                type="textarea"
                :disabled="showBuyable"
                :rows="6" />
            </div>
          </div>
        </div>
        <div class="box">
          <refer-underwriting
            ref="refer-underwriting"
            :form="item"
            :classId="item.class_id"
            :disabled="showBuyable"
            :editType="editType"
            :renewOrderId="renewOrderId"
            :formDataLock="excessFormDataLock"
            @sendPlanCvrRemark="getPlanCvrRemark"
            @getSubmitPremium="getSubmitPremium"
            @getFormData="submitPremium" />
        <!--        <h3>Underwriting Question</h3>-->
        <!--        <div class="flex-sb-wrap">-->
        <!--          <div-->
        <!--            v-for="(inItem, inIndex) in item.underwriting"-->
        <!--            :key="inIndex"-->
        <!--            class="form-item form-half">-->
        <!--            <span>{{ inItem.name }}</span>-->
        <!--            <v-radio-group-->
        <!--              v-model="inItem.answer"-->
        <!--              :disabled="showBuyable"-->
        <!--              :border="true"-->
        <!--              :list="yesNoOptions" />-->
        <!--          </div>-->
        <!--        </div>-->
        </div>
        <premium-form
          ref="premium"
          :classId="item.class_id"
          :customerId="customerId"
          :form="item"
          :index="index"
          :is-fina="isFina"
          :benefitList="benefitList"
          :editType="editType"
          :renewOrderId="renewOrderId"
          :disabled="showBuyable"
          :formDataLock="excessFormDataLock"
          @submitPremium="submitPremium"
          @getSubmitPremium="getSubmitPremium"></premium-form>
      </div>
    </el-form>
  </section>
</template>
<script>
import MixinRules from '@/mixins/rules'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import PremiumForm from '@/views/components/premium-form'
import benefitForm from '@/views/tickets/components/modules/component/more-benefit'
import referUnderwriting from '@/views/tickets/components/form/refer-underwriting'
import MixinReplyRefer from '@/mixins/reply-refer'
export default {
  name: 'HousemaidReplyReferForm',
  components: {
    PremiumForm,
    benefitForm,
    referUnderwriting
  },
  mixins: [MixinOptions, MixinRules, MixinFormat,MixinReplyRefer],
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    index: [String, Number],
    customerId: {
      type: [Number,String],
      default: '' // 1 - reply, 2 - upgrade
    },
    referId: [String, Number],
    showBuyable:{
      type:Boolean,
      default:false
    },
    isFina:{
      type:Boolean,
      default:false
    },
    editType: {
      type: Number,
      default: 1 // 1 - reply, 2 - upgrade, 3 - renew
    },
    renewOrderId:{
      type: [Number, String],
      default: null
    },
    reject_fileData:{
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      excessFormDataLock: 0, // 因爲 home fire excess 數據是動態的，所以需要動態鎖定表單
      parentOtherData: null,
      quoteStatusOptions: [
        {
          name: 'Quoted',
          id: 1
        },
        {
          name: 'Rejected',
          id: 0
        },
      ],
      subForm: {
        'premium':false,
        'benefit-form':false,
      },
      plan_cvr_remark: '',
      benefitList: [],
      otherData:{
        target: 'renew_file_path_id',
        index: this.index,
        name: 'travel-reply-refer-form'
      }
    }
  },
  computed: {
    formRules() {
      const {quote_status} = this.item
      var rule = JSON.stringify(this.rules)
      const data =[
        'basic_prm',
        'code_disc_pct',
        'ia_levy_pct',
        'spec_disc_pct',
        'handling_fee',
        'age_limits'
      ]
      rule = JSON.parse(rule)
      data.forEach(item=>{
        rule[item][0].required =false
      })
      return quote_status==0? rule:this.rules
    },
    localAllOptions() {
      return this.allOptions23
    },
    currentPlanOptions() {
      if(!this.globalOptions || !this.globalOptions.plan) {
        return []
      }
      const { class_id, company_id } = this.item
      const key = `${company_id}${class_id}`
      return this.globalOptions.plan.filter(item => item.category_id == key)
    }
  },
  watch:{
    'item.plan_id': {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          this.changePlan()
        }
      }
    },
    'item.quote_status':{
      immediate: true,
      deep: true,
      handler(val){
        if(val == 1){
          this.handleDel({otherData: this.otherData})
        }
      }
    }
  },
  methods: {
    handleDel(otherData){
      this.$emit('delete', otherData)
    },
    handlerUploadSuccess(uploadRsult){
      this.$emit('uploadSuccess',uploadRsult)
    },
    getSubFormData(data) {
      Object.assign(this.item, data)
      this.$emit('validate', this.parentOtherData)
    },
    getSubmitPremium(data, index, name){
      if(name == 'benefit'){
        this.benefitList = []
        Object.assign(this.benefitList, data.benefits)
      }
      Object.assign(this.item, data)
      this.$forceUpdate()
    },
    getPlanCvrRemark(data){
      this.plan_cvr_remark = data
    },
    submitPremium(form,data){
      this.subForm[form] = true
      Object.assign(this.item, data)
    },
    handlerReferralMain() {
      this.$emit('getPremium', this.index)
    },
    planOptions() {
      const { class_id, company_id } = this.item
      if(!class_id || !company_id) return []

      const key = `${company_id}${class_id}`
      const { plan } = this.globalOptions
      const options = plan[key]
      if(!options) return []
      return options
    },
  }
}
</script>
